import { SlotSearchParams } from '../Model/Slot';

/** GET /slots/ 쿼리용: undefined/null만 제외해 URL·백엔드 파싱 부담을 줄임 (스펙상 선택 파라미터) */
export function compactSlotSearchParams(
  params?: SlotSearchParams,
): Record<string, string | number> | undefined {
  if (!params) return undefined;
  const out: Record<string, string | number> = {};
  const assign = (k: keyof SlotSearchParams) => {
    const v = params[k];
    if (v !== undefined && v !== null) {
      out[k as string] = v as string | number;
    }
  };
  assign('page');
  assign('pageSize');
  assign('slotId');
  assign('sellerId');
  assign('creatorId');
  assign('keyword');
  assign('url');
  assign('mid_single');
  assign('mid_compare');
  assign('active');
  assign('order_by');
  assign('order_dir');
  return Object.keys(out).length > 0 ? out : undefined;
}
